<template>
	<div class="tabs-view">
		<div v-for="(tab, i) in tabs" :key="i" @click="onChange($event, tab)" :class="{
			tab: true,
			active: value == tab.value
		}">{{ tab.label }}<div class="badge" :key="i" v-if="tab.badge && tab.badge.visible" :style="{
			backgroundColor: tab.badge && tab.badge.style && tab.badge.style.background && tab.badge.style.background.color ? tab.badge.style.background.color : 'inherit',
			color: tab.badge && tab.badge.style && tab.badge.style.font && tab.badge.style.font.color ? tab.badge.style.font.color : 'inherit',
			marginLeft: tab.label ? '7px' : '0'
		}">{{ tab.badge.label }}</div></div>
	</div>
</template>

<script>
	export default {
		props: {
			tabs: {
				type: Array,
				default() {
					return []
				}
			},
			value: {
				type: String,
				default: null
			}
		},
		methods: {
			onChange(e, tab) {
				
				this.$emit('onChange', tab);
				this.$emit('input', tab.value);

				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.tabs-view {
		height: 54px;
		padding: 0 ! important;

		& > .tab {
			box-sizing: border-box;
			color: black;
			float: left;
			line-height: 54px;
			height: 54px;
			font-size: 14px;
			margin-right: 20px;
			cursor: pointer;
			border-bottom: 3px solid #00000000;

			& > .badge {
				float: right;
				font-size: 12px;
				text-align: center;
				border-radius: 13px;
				line-height: 26px;
				margin-left: 7px;
				padding: 0 7px 0 7px;
				margin-top: 14px;
				min-width: 26px;
			}

			&.active {
				border-color: #f7223f;
			}
		}
	}
</style>